module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_5_preview.732cfff0.jpg";